const workflowAccessPointMap = {
  it_acquista: '/it/acquista/',
  en_buy: '/en/buy/',
  my_account_orders_new: '/my-account/orders/kit/',
}
export default workflowAccessPointMap
